import { ISearchWidget } from 'features/search-widget';

const bookabachSearchWidgetConfig: Record<string, ISearchWidget> = {
  'nz-bookabach': {
    branding: {
      logo: {
        url: 'https://www.bookabach.co.nz/_dms/header/logo.svg?siteid=9006043&locale=en_NZ&3ec60977',
        description: 'Bookabach.co.nz',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'www.bookabach.co.nz',
      searchParams: {
        siteid: '9006043',
        langid: '5129',
      },
      stays: {
        pathname: '/search',
      },
    },
  },
};

export { bookabachSearchWidgetConfig };
